import React from 'react'
import { useAtom, useSetAtom } from 'infrastructure/state/jotai.wrapper'

import { customRegexAtom, customRegexFormatAtom } from '../atoms'
import { Box, Chip, FormControl, TextField } from '@mui/material'
import { createRegexFromFormat } from '../utilities/utility'

export const StructureRegexComposer = () => {
  const [customFormat, setCustomFormat] = React.useState<string>(
    'SCMath_6-8_G{grade}_U{unit}_L{lesson}_{name}',
  )
  const [_, setCustomRegex] = useAtom(customRegexAtom)

  const setFormat = useSetAtom(customRegexFormatAtom)

  return (
    <Box sx={{ mb: 2 }}>
      <FormControl>
        <Box mb={1}>
          Use
          <Chip
            label="{grade}"
            onClick={() => setCustomFormat(`${customFormat}{grade}`)}
          />
          <Chip
            label="{unit}"
            onClick={() => setCustomFormat(`${customFormat}{unit}`)}
          />
          <Chip
            label="{lesson}"
            onClick={() => setCustomFormat(`${customFormat}{lesson}`)}
          />
          <Chip
            label="{character}"
            onClick={() => setCustomFormat(`${customFormat}{character}`)}
          />
          <Chip
            label="{name}"
            onClick={() => setCustomFormat(`${customFormat}{name}`)}
          />
          to create a custom format for the file name to match the lesson
        </Box>
        <TextField
          value={customFormat}
          onChange={(e) => setCustomFormat(e.target.value)}
          variant={'standard'}
          onBlur={(e) => {
            setCustomFormat(e.target.value)
            setFormat(customFormat)
            const newRegex = createRegexFromFormat(customFormat)
            return setCustomRegex(newRegex)
          }}
        />
      </FormControl>
    </Box>
  )
}
